/*
*
* ValidateEmail Constants
*
*/
export const VALIDATE_EMAIL = 'src/components/Features/public/ValidateEmail/VALIDATE_EMAIL';